import React from 'react';
import { Link } from 'react-router';
import classnames from 'classnames';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { Buttons } from '../buttons';
import cssBase from '../../collect-sizes-popup.scss';
import css from './generated-link-dialog.scss';
export const GeneratedLinkDialog = ({
  link,
  isLimitedEdition,
  onCopy,
  onClose
}) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(link);
    onCopy();
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    className: classnames(cssBase.header, {
      [cssBase.headerLE]: isLimitedEdition
    })
  }, "Here is the link to send your recipients!"), /*#__PURE__*/React.createElement("p", {
    className: cssBase.text
  }, "Below is the unique link you can copy and send to your recipients for them to submit their sizes. You can also easily access this link and track submissions in your account", ' ', /*#__PURE__*/React.createElement(Link, {
    className: css.link,
    to: APP_ROUTES.SIZE_SUBMISSIONS
  }, "here"), "."), /*#__PURE__*/React.createElement("div", {
    className: cssBase.inputWrapper
  }, /*#__PURE__*/React.createElement("input", {
    "data-input": "LinkURL",
    value: link,
    disabled: true
  }), /*#__PURE__*/React.createElement("div", {
    className: css.copyButton,
    onClick: handleCopy
  }, "Copy")), /*#__PURE__*/React.createElement(Buttons, {
    isButtonResponsive: true,
    onNextButton: onClose,
    nextText: "Close"
  }));
};